/**
 * TelemetryAlertsListener — toasts de RECUPERAÇÃO da telemetria.
 *
 * Os avisos de PROBLEMA (dispositivo crítico, profissional offline e excesso
 * de velocidade) são emitidos pela Central de Notificações
 * (Configurações > Notificações → `telemetry.critical`,
 * `telemetry.offline`, `telemetry.speed_violation`), que respeita som, tempo
 * de toast, atraso e horário silencioso. Este listener NÃO os duplica mais —
 * antes o mesmo evento aparecia duas vezes na tela.
 *
 * Aqui ficam apenas as voltas ao normal, que não têm evento parametrizado:
 *  - telemetry:critical (entered=false) → voltou ao normal
 *  - telemetry:online                  → prestador voltou a pingar
 *
 * Não renderiza nada. Monte uma única vez na raiz autenticada.
 */
import { useEffect } from "react";
import { toast } from "./ui/sonner";
import { subscribeAdminWS } from "@/lib/adminWS";
import { Wifi } from "lucide-react";

export default function TelemetryAlertsListener() {
  useEffect(() => {
    const unsub1 = subscribeAdminWS("telemetry:critical", (d) => {
      if (!d || d.entered) return;
      toast.success(`${d.person_name}: voltou ao normal (${d.label})`, {
        duration: 5_000,
        id: `crit-${d.person_id}-${d.reason}-ok`,
      });
    });

    const unsub2 = subscribeAdminWS("telemetry:online", (d) => {
      if (!d?.person_id) return;
      toast.success(`${d.person_name} voltou online`, {
        icon: <Wifi size={18} />,
        duration: 5_000,
        id: `online-${d.person_id}`,
      });
    });

    return () => {
      unsub1?.();
      unsub2?.();
    };
  }, []);

  return null;
}
